"use client";

import publicConfig from "@/config/public.config";
import { setAnonymousUserIdCookieFromSession } from "@/lib/auth/anonymous-user-cookie";
import { createClient } from "@/utils/supabase/client";

export type GoogleHandoffParams = {
  handoffId?: string | null;
  token?: string | null;
  landingId?: string | null;
};

export async function signInWithGoogle(
  returnUrl?: string,
  handoff?: GoogleHandoffParams,
) {
  const supabase = createClient();
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (session?.user.is_anonymous) {
    await setAnonymousUserIdCookieFromSession();
  }

  const next = returnUrl || "/";
  const callbackUrl = new URL(`${publicConfig.baseUrl}/auth/callback`);
  callbackUrl.searchParams.set("next", next);

  if (handoff?.handoffId) {
    callbackUrl.searchParams.set("handoff_id", handoff.handoffId);
  }
  if (handoff?.token) {
    callbackUrl.searchParams.set("token", handoff.token);
  }
  if (handoff?.landingId) {
    callbackUrl.searchParams.set("landing_id", handoff.landingId);
  }

  console.log("callbackUrl", callbackUrl.toString());

  return supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: callbackUrl.toString(),
    },
  });
}
